import { enUS } from '@src/i18n/languages/en-US';
import { enGB } from '@src/i18n/languages/en-GB';
import jaJP from '@src/i18n/languages/ja-JP';

// formatters for currency, numbers, datetime etc
import US from '@src/i18n/formatters/US';
import GB from '@src/i18n/formatters/GB';
import JP from '@src/i18n/formatters/JP';

const messages = {
  'en-US': enUS.default,
  'en-GB': enGB.default,
  'ja-JP': jaJP,
};

const numberFormats = {
  'en-US': US.numberFormats,
  'en-GB': GB.numberFormats,
  'ja-JP': JP.numberFormats,
};

const datetimeFormats = {
  'en-US': US.datetimeFormats,
  'en-GB': GB.datetimeFormats,
  'ja-JP': JP.datetimeFormats,
};

const defaultLocale = 'en-US';
const supportedLocales = ['en-US', 'en-GB', 'ja-JP'];

export {
  messages,
  numberFormats,
  datetimeFormats,
  defaultLocale,
  supportedLocales,
};
